import { useEffect } from "react";
import { supabase } from "../providers/supabase/supabase";

const INTERVALO_MS = 60_000;

/**
 * Manda um "heartbeat" a cada 60s enquanto a aba está em primeiro plano —
 * vira `minutos_ativos` em `user_atividade_diaria` (migration 153), a base
 * de "tempo dentro da plataforma" no North Insights.
 *
 * Só conta com a aba VISÍVEL (Page Visibility API): minimizada ou em outra
 * aba não soma, senão "tempo de uso" infla com abas esquecidas abertas.
 * `registrar_heartbeat()` só grava a PRÓPRIA pessoa (auth.uid() no RPC) e
 * vira no-op se não houver sessão — por isso este hook pode ficar montado
 * sempre, mesmo antes do login.
 *
 * Múltiplas abas da mesma pessoa somam heartbeat em dobro — limitação
 * conhecida, documentada também na migration e no Insights.
 */
export const useHeartbeat = () => {
  useEffect(() => {
    const bater = async () => {
      if (document.visibilityState !== "visible") return;
      try {
        const { data } = await supabase.auth.getSession();
        if (!data?.session) return;
        await supabase.rpc("registrar_heartbeat");
      } catch {
        // Heartbeat é acessório: uma falha de rede aqui não pode incomodar
        // quem está usando a plataforma. Silenciosa de propósito.
      }
    };

    bater();
    const intervalId = setInterval(bater, INTERVALO_MS);
    return () => clearInterval(intervalId);
  }, []);
};

export default useHeartbeat;
